import { useEffect, useState } from 'react';
import { PLAYBACK_RATE } from '../constants/local_storage_constants';

const normalizePlaybackRate = value => {
    const rate = Number(value);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
};

const currentRate = audio => {
    if (audio?.currentSrc || audio?.getAttribute('src')) return normalizePlaybackRate(audio.playbackRate);
    // Before any audio is loaded, show the preference that playback will use.
    try {
        const savedRate = localStorage.getItem(PLAYBACK_RATE);
        if (savedRate !== null) return normalizePlaybackRate(savedRate);
    } catch {
        // Storage can be unavailable in private or restricted browser contexts.
    }
    return normalizePlaybackRate(audio?.playbackRate);
};

export default function useAudioPlaybackRate() {
    const audio = document.getElementById('audio');
    const [rate, setRate] = useState(() => currentRate(audio));

    useEffect(() => {
        setRate(currentRate(audio));
        const onRateChange = () => setRate(normalizePlaybackRate(audio?.playbackRate));
        const onStorage = event => {
            if (event.key === PLAYBACK_RATE || event.key === null) setRate(currentRate(audio));
        };
        audio?.addEventListener('ratechange', onRateChange);
        window.addEventListener('storage', onStorage);
        return () => {
            audio?.removeEventListener('ratechange', onRateChange);
            window.removeEventListener('storage', onStorage);
        };
    }, [audio]);

    return rate;
}
